module.exports = {
    NO_MATCH_FOUND: 'No se encontraron ONGs con esa búsqueda',
    PLACEHOLDER_NGO_SEARCH: 'Selecciona ONG o Fundación',
    LABEL_SEARCHER_INPUT: 'Selecciona hasta 5 ONG a la que quieres hacer tu donación',
    YOUR_NGO: '¿No encuentras tu ONG?',
    SELECTED_NGO: 'ONGs seleccionadas',
    NGO_LIST: 'Listado de ONG',
    SELECTED_PL: 'seleccionadas',
    SELECTED: 'seleccionada',
    BOX_FOOTER: 'Ver detalles',
    TOOLTIP_TEXT1: '¿Quieres añadir una organización a Open Solidario?',
    TOOLTIP_TEXT2: 'Escríbenos tu propuesta a',
    E_MAIL: 'opensolidario@openbank.es',
    DEFAULT_TOKEN: ''
};